export default __webpack_public_path__ + "static/media/live.439fc64c.gif";